module.exports = __webpack_public_path__ + "images/04ff4e84c6a65c062d7cb40f3b8c0e1c-bronze_badge.png";